import { provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { applyInitialUrl } from './app/core/utils/locale-url';
import { IS_ESS_HOST } from './app/core/utils/app-host';

// index.html has the New PTM title; until the translated title is set
if (IS_ESS_HOST) {
  document.title = 'Employee Self Service';
}

// /en/... and /fr/... links set the language, and ESS / New PTM URLs are mapped to their hostname, before the router
// reads the URL
if (applyInitialUrl()) {
  platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
    .catch(err => console.error(err));
}
